export const ResourceType = Object.freeze({
    Newsletter: 0,
    Webinar: 1
});